export const deleteGroups = (item, setTargetField, requiredData) => {
  const remaining = requiredData.filter((e) => e.tId != item.tId);
  let other = requiredData.filter((e) => e.groupName != item.groupName);
  const collections = remaining.filter((e) => e.groupName == item.groupName);
  const collectionsData = collections.map((e, i) => {
    if (collections.length == 1) {
      return {
        ...e,
        isCollectionStart: true,
        isCollectionEnd: true,
      };
    }

    if (i === 0) {
      return {
        ...e,
        isCollectionStart: true,
        isCollectionEnd: false,
      };
    }

    if (i === collections.length - 1) {
      return {
        ...e,
        isCollectionStart: false,
        isCollectionEnd: true,
      };
    }
    return {
      ...e,
      isCollectionStart: false,
      isCollectionEnd: false,
    };
  });
  setTargetField([...other, ...collectionsData]);
};
